import * as AuthenticationTypes from './types';
import * as AuthenticationConstants from './constants';
import * as EmailTypes from '../email/types';
import { REFRESH_PROFILE_TEMP_SUCCESS } from '../profileTemp/types';

const initialState = {
    isAuthenticated: false,
    initialized: false,
    loginMethod: AuthenticationConstants.LOGIN_METHOD_USERNAME,
    error: null,

    // EMAIL
    access_token: '',
    refresh_token: '',
    expires_in: '', // seconds, from when the token was acquired
    token_type: '',
    expiration_date: 0, // ms since epoch

    /** The authorization header for the current login method */
    authorization: '',

    xDeviceId: '',
};

const AuthenticationReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case AuthenticationTypes.LOG_OUT:
            return {
                ...initialState,
                loginMethod: state.loginMethod, // return initial state but preserve login method
                initialized: true,
            };
        case AuthenticationTypes.SET_INITIALIZED:
            return {
                ...state,
                initialized: action.payload.initialized,
            };
        case AuthenticationTypes.SET_AUTHENTICATED:
            return {
                ...state,
                isAuthenticated: action.payload.isAuthenticated,
            };
        case AuthenticationTypes.REMOVE_ERROR:
            return {
                ...state,
                error: false,
            };
        case AuthenticationTypes.SET_LOGIN_METHOD:
            return {
                ...state,
                loginMethod: action.payload.loginMethod,
            };
        case AuthenticationTypes.SET_AUTHORIZATION_HEADER:
            return {
                ...state,
                authorization: action.payload.value,
            };
        case AuthenticationTypes.CLEAR_AUTHORIZATION_HEADER:
            return {
                ...state,
                authorization: '',
            };

        // EMAIL
        case EmailTypes.LOGIN_EMAIL_SUCCESS:
            return {
                ...state,
                ...action.payload, // access_token, refresh_token, expires_in, token_type, expiration_date
                error: false,
            };
        case EmailTypes.LOGIN_EMAIL_FAIL:
            // return initial state but preserve login method
            return {
                ...initialState,
                loginMethod: state.loginMethod,
                initialized: true,
                error: action.payload.error,
            };
        case EmailTypes.REFRESH_EMAIL_SUCCESS:
            return {
                ...state,
                ...action.payload, // access_token, refresh_token, expires_in, token_type, expiration_date
                error: false,
            };
        case EmailTypes.REFRESH_EMAIL_FAIL:
            // return initial state (logged out) but preserve login method & set initialized
            return {
                ...initialState,
                loginMethod: state.loginMethod,
                initialized: true,
                error: action.payload.error,
            };

        // PROFIL TEMP
        case REFRESH_PROFILE_TEMP_SUCCESS:
            return {
                ...state,
                initialized: true,
                ...action.payload,
            };
        default:
            return state;
    }
};

export { AuthenticationReducer };
